import axios from "axios";

export function getContractTypeList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "ContractType/getlist", config);
}

export function postContract(data) {
    return axios.post(process.env.VUE_APP_API_URL + "Contract/insert", data);
}

export function getContractList(co) {
    const config = {
      params: co,
    };
    return axios.get(process.env.VUE_APP_API_URL + "Contract/getlist", config);
}

export function deleteContract(id) {
    const config = {
      params: {
        id: id,
      },
    };  
    return axios.delete(process.env.VUE_APP_API_URL + "Contract/deleted", config);
}

export function getContractById(contractId) {
    const config = {
      params: {
        contractId: contractId,
      },
    };  
    return axios.get(process.env.VUE_APP_API_URL + "Contract/getbyid", config);
}

export function updateContract(data) {
    return axios.put(process.env.VUE_APP_API_URL + "Contract/update", data);
}
export function getSellingContract(data) {
  const config = {
    params: {
      language: data.locale,
    },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Contract/distancesellingcontract", data, config);
}
